/* Time helpers. The backend serialises naive UTC datetimes (no offset), so
   every timestamp must be parsed as UTC; parsing them bare would shift them
   by the viewer's offset. One definition, used everywhere. */

export const parseUtc = (iso) => {
  if (iso == null || iso === '') return null;
  const s = String(iso);
  const hasOffset = /([zZ]|[+-]\d\d:?\d\d)$/.test(s);
  return new Date(hasOffset ? s : `${s}Z`);
};

export const fmtCount = (n) => (n == null ? '\u2014' : n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`);

export const ago = (iso) => {
  if (!iso) return 'never';
  const s = Math.max(0, (Date.now() - parseUtc(iso).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const until = (iso) => {
  if (!iso) return null;
  const s = (parseUtc(iso).getTime() - Date.now()) / 1000;
  if (s <= 0) return 'due now';
  if (s < 3600) return `in ${Math.floor(s / 60)}m`;
  if (s < 86400) return `in ${Math.floor(s / 3600)}h`;
  return `in ${Math.floor(s / 86400)}d`;
};
